export const convertCase = (value: string) =>
  value && value.length > 0
    ? `${value.substr(0, 1).toUpperCase()}${value.substr(1).toLowerCase()}`
    : '';
